import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=2174a951&lang=pug"
import script from "./Content.vue?vue&type=script&lang=coffee"
export * from "./Content.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports